import { defineMessages } from 'react-intl';

export default defineMessages({
    verifyGroupDiscounts: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.Next, We\'ll verify Group discounts',
        defaultMessage: 'Next, we\'ll verify {groupdiscounts}'
    },
    discounts: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.Discounts',
        defaultMessage: 'Discounts'
    },
    groupDiscounts: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.Group discounts',
        defaultMessage: 'Group discounts'
    },
    chooseNamedInsured: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.Choose the name of the person who will be the named insured on this quote',
        defaultMessage: 'Choose the name of the person who will be the named insured on this quote'
    },
    addNewNameButton: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.ADD NEW NAME',
        defaultMessage: 'ADD NEW NAME'
    },
     periodStartDateError: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.periodStartDateError',
        defaultMessage: 'The Effective Date must be on or after the {newBusinessEffectiveDate} per the agreement with the Group Account.'
    },
    updateInfoBelow: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.Update information for the selected policyholder below',
        defaultMessage: 'Update information for the selected policyholder below'
    },
    policyAddrSearchLabel: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.addressDetails.Enter street address (No PO Box)',
        defaultMessage: 'Enter street address (No PO Box)'
    },
    propertyAddressLabel: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.Property Address',
        defaultMessage: 'Property Address'
    },
    insuredAddressLabel: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.Insured Address',
        defaultMessage: 'Insured Address'
    },
    sameMailingAddressQuestion: {
        id: 'ml.gatewayquoteandbind.common.Is mailing address the same as the above address?',
        defaultMessage: 'Is mailing address the same as the above address?'
    },
    mailingAddressLabel: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.mailingAddress.Mailing address',
        defaultMessage: 'Mailing Address'
    },
    mailingAddrSearchLabel: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.mailingAddress.Enter mailing address',
        defaultMessage: 'Enter mailing address'
    },
    policyEffectiveDate: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.Policy Effective Date',
        defaultMessage: 'Policy Effective Date'
    },
    customerHeader: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.Customer',
        defaultMessage: 'Customer'
    },
    onePhoneMustBePrimary: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.One phone must be a primary',
        defaultMessage: 'One phone must be a primary'
    },
    productNotAvailableInState: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.productNotAvailableInState',
        defaultMessage: 'Sorry – the digital policy is not available in this state. Please resume the quote process in an eligible state.'
    },
    technicalDifficulties: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.technical difficulties',
        defaultMessage: 'We’re sorry. Due to technical difficulties, we are unable to process your quote at this time. Please try again later. Thank you.'
    },
    permissionDifficulties: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.permissionDifficulties',
        defaultMessage: 'You do not have the permission required to perform this action: User does not have sufficient permission to perform this task.'
    },
    closeWindow: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.Close Window',
        defaultMessage: 'Close Window'
    },
    SNIAndPNICannotBeTheSameContactML: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.The primary and secondary name cannot be the same person',
        defaultMessage: 'The primary and secondary named insured cannot be the same person'
    },
    baseWizardMessageNonRenters: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.wizardMessagePa',
        defaultMessage: 'We’ll find your {groupdiscounts} next'
    },
    driversAndVehicles: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.driversAndVehicles',
        defaultMessage: 'drivers and vehicles'
    },
    electronicToPaperWarning: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.electronicToPaperWarning',
        defaultMessage: '<b>A valid email address is required to receive electronic communications. If you don’t enter an email address, the paperless discount will be removed.</b><br></br>Please review before proceeding.'
    },
    bypassCreditOrdering: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.Bypass Credit Ordering',
        defaultMessage: '<b>Bypass Credit Ordering</b>'
    },
    invalidEmail:{
        id:'ml.gatewayquoteandbind.common.YourInfo.invalidEmail',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    },
    pniUpdateInvalid:{
        id:'ml.gatewayquoteandbind.common.YourInfo.PNI Update Invalid',
        defaultMessage:"The primary insured cannot be changed to a different person"
    },
    mlDatabaseBeanVersionConflictMessage: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.databaseBeanVersionConflictMessage',
        defaultMessage: 'The System is experiencing simultaneous updates for this quote. Please wait a few seconds and continue'
    },
    firstPersonInControl: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.PNI.FirstPersonInControl',
        defaultMessage: 'First Person in Control'
    },
    primaryNamedInsured: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.PNI.PrimaryNamedInsured',
        defaultMessage: 'Primary Named Insured'
    },
     spouseRequired: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.PNI.spouseRequired',
        defaultMessage: 'Spouse information is required as a Secondary Named Insured when the Primary Named Insured marital status is married.'
    },
     primaryMaritalStatusInvalid: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.PNI.primaryMaritalStatusInvalid',
        defaultMessage: 'An update to the marital status of the primary named insured is required. Marital status cannot be single when the secondary named insured is a spouse.'
    },
    secondaryMaritalStatusInvalid: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.PNI.secondaryMaritalStatusInvalid',
        defaultMessage: 'An update to the marital status of the secondary named insured is required. Marital status cannot be single when the secondary named insured is a spouse.'
    },
    fieldRequired: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.PNI.Required',
        defaultMessage: 'Please enter the missing information. This field is required.'
    },
     pniSingleNoSni: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.PNI.pniSingleNoSni',
        defaultMessage: 'A spouse has been identified on another policy. Please navigate back to the Customer Details screen to review and correct the prefilled spouse name.'
    },
     pniSingleSniNoSpouse: {
        id: 'ml.gatewayquoteandbind.common.YourInfo.PNI.pniSingleSniNoSpouse',
        defaultMessage: 'A spouse has been identified on another policy. Please navigate back to the Customer Details screen to review.'
    },
    changeMailingAddressOnEffectiveDate:{
        id: 'ml.gatewayquoteandbind.common.changeMailingAddressOnEffectiveDate',
        defaultMessage: 'Change mailing address to the policy address on the effective date?'
    },
    producerCodeChanged: {
        id: 'ml.gatewayquoteandbind.common.producerCodeChanged',
        defaultMessage: 'This producer does not have an active license, appointment, or state authority for this quote. To continue, we have automatically updated the producer code to the primary group producer. If you are a non-licensed (NL) user or would like to be appointed, please contact Agency Contract Management at 1-800-237-6136 for assistance. '
    },
    selectDiffProducerCode: {
        id: 'ml.gatewayquoteandbind.common.selectDiffProducerCode',
        defaultMessage: 'Please try selecting a different producer code.'
    }

   });
